export const PercentageFormat = (number) => {
  if (isNaN(number) || number === null || number === undefined) {
    return "0.00%"; // Default value if number is invalid
  }
  
  const num = typeof number === 'string' ? parseFloat(number) : Number(number);
  
  if (isNaN(num)) {
    return "0.00%";
  }
  const formatted = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num / 100); 
  if (formatted.endsWith('.00%')) {
    return formatted.slice(0, -4) + '%'; 
  }
  
  return formatted;
};